export enum FeatureCodePrefix {
  preInstalled = 'pre-installed',
  miscOption = 'misc_option',
}
